var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3070(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3070",
    "data-name": "Group 3070",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69857",
    "data-name": "Path 69857",
    d: "M197.96,409.82a18,18,0,1,1,18-18A18,18,0,0,1,197.96,409.82Zm0-32.8a14.8,14.8,0,1,0,14.794,14.8A14.8,14.8,0,0,0,197.96,377.017Z",
    transform: "translate(-179.961 -373.82)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69858",
    "data-name": "Path 69858",
    d: "M207.392,400.1a3.368,3.368,0,0,0-3.076,3.4v3.149a.771.771,0,1,1-1.542,0V393.466a3.368,3.368,0,0,0-3.076-3.408,3.246,3.246,0,0,0-3.481,3.246v13.309a.812.812,0,0,1-1.55,0v-9.3a3.368,3.368,0,0,0-3.076-3.4,3.246,3.246,0,0,0-3.481,3.246v9.487a16.377,16.377,0,0,0,22.723,0v-3.311a3.246,3.246,0,0,0-3.441-3.238Z",
    transform: "translate(-181.496 -376.878)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1549",
    "data-name": "Ellipse 1549",
    cx: 2.93,
    cy: 2.93,
    r: 2.93,
    transform: "translate(7.197 9.601)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1550",
    "data-name": "Ellipse 1550",
    cx: 2.93,
    cy: 2.93,
    r: 2.93,
    transform: "translate(15.199 4.805)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1551",
    "data-name": "Ellipse 1551",
    cx: 2.93,
    cy: 2.93,
    r: 2.93,
    transform: "translate(23.201 16.003)",
    fill: "#cf2969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3070);
export default __webpack_public_path__ + "static/media/Group 3070.fa93eb7bcbfe9161f7053a91d417d9da.svg";
export { ForwardRef as ReactComponent };